// Simple audio utilities for notification sounds
import messageSound from '../assets/sound/message_sound_effect.mp3';
import notificationSound from '../assets/sound/notif_sound_effect.mp3';

// Create audio elements with the imported sounds
const messageAudio = new Audio(messageSound);
const notificationAudio = new Audio(notificationSound);

// Configure audio settings
messageAudio.volume = 0.5;
notificationAudio.volume = 0.5;

// Check if user has enabled sounds in localStorage
const isSoundEnabled = () => {
  const soundsEnabled = localStorage.getItem('notificationSounds');
  // If not set or explicitly set to true, return true
  return soundsEnabled === null || soundsEnabled === 'true';
};

// Play message notification sound
export const playMessageSound = () => {
  if (isSoundEnabled()) {
    try {
      console.log("Playing message sound...");
      // Reset the sound to the beginning if it's already playing
      messageAudio.pause();
      messageAudio.currentTime = 0;
      
      // Create a promise to play the sound
      const playPromise = messageAudio.play();
      
      // Handle play promise errors properly
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Message sound played successfully");
          })
          .catch(err => {
            console.error("Error playing message sound:", err);
          });
      }
    } catch (err) {
      console.error("Exception playing message sound:", err);
    }
  }
};

// Play general notification sound
export const playNotificationSound = () => {
  if (isSoundEnabled()) {
    try {
      console.log("Playing notification sound...");
      // Reset the sound to the beginning if it's already playing
      notificationAudio.pause();
      notificationAudio.currentTime = 0;
      
      // Create a promise to play the sound
      const playPromise = notificationAudio.play();
      
      // Handle play promise errors properly
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log("Notification sound played successfully");
          })
          .catch(err => {
            console.error("Error playing notification sound:", err);
          });
      }
    } catch (err) {
      console.error("Exception playing notification sound:", err);
    }
  }
};

// Toggle notification sounds on/off
export const toggleNotificationSounds = () => {
  const currentSetting = isSoundEnabled();
  localStorage.setItem('notificationSounds', (!currentSetting).toString());
  return !currentSetting;
};

export const getNotificationSoundState = () => isSoundEnabled(); 